import {
  exportAllOutboundTransport,
  exportAllOutboundTransportErrors,
  exportOutboundTransportRoute,
  exportOutboundTransportRouteErrors,
} from "@/api/transport";
import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import { TooltipPlacement } from "antd/es/tooltip";
import { ReactNode, useState } from "react";

export default function ExportOutboundTransportAction({
  children,
  route,
  year,
  onSuccess,
  placement = "bottom",
}: {
  children: ReactNode;
  route?: {
    departure_facility_id: number;
    arrival_facility_id?: number;
    arrival_name: string;
    by_transport_category: boolean;
  };
  year?: number;
  onSuccess?: () => void;
  placement?: TooltipPlacement;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const onFinish = () => {
    onSuccess?.();
    setIsOpen(false);
  };

  return (
    <ActionsPopover
      open={isOpen}
      onOpenChange={setIsOpen}
      placement={placement}
      actions={
        <>
          {route && (
            <>
              <FileDownloader
                fileOutputName={`export-outbound-transport-route-${route?.departure_facility_id}-${encodeURIComponent(
                  route.arrival_name
                )}.xlsx`}
                fileUrlFn={() =>
                  exportOutboundTransportRoute(
                    route?.departure_facility_id,
                    route?.arrival_name,
                    route?.by_transport_category
                  )
                }
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export all
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
              <FileDownloader
                fileOutputName={`export-outbound-transport-route-${year}-${route?.departure_facility_id}-${encodeURIComponent(
                  route.arrival_name
                )}.xlsx`}
                fileUrlFn={() =>
                  exportOutboundTransportRoute(
                    route?.departure_facility_id,
                    route?.arrival_name,
                    route?.by_transport_category,
                    year
                  )
                }
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export {year}
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
              <FileDownloader
                fileOutputName={`export-outbound-transport-errors-${year}-${route?.departure_facility_id}-${encodeURIComponent(
                  route.arrival_name
                )}.xlsx`}
                fileUrlFn={() =>
                  exportOutboundTransportRouteErrors(
                    route?.departure_facility_id,
                    route?.arrival_name,
                    route?.by_transport_category,
                    year
                  )
                }
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export errors
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
            </>
          )}
          {!route && (
            <>
              <FileDownloader
                fileOutputName={`export-outbound-transport.xlsx`}
                fileUrlFn={() => exportAllOutboundTransport({})}
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export all
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
              <FileDownloader
                fileOutputName={`export-outbound-transport-${year}.xlsx`}
                fileUrlFn={() => exportAllOutboundTransport({ year })}
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export {year}
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
              <FileDownloader
                fileOutputName={`export-outbound-transport-errors-${year}.xlsx`}
                fileUrlFn={() => exportAllOutboundTransportErrors({ year })}
                onFinish={onFinish}
                customRender={(props) => (
                  <ActionsPopOverItem
                    {...props}
                    black
                  >
                    Export errors
                  </ActionsPopOverItem>
                )}
                addTimestampAndCompany={true}
              />
            </>
          )}
        </>
      }
    >
      {children}
    </ActionsPopover>
  );
}
